export const en = {
    welcome: 'Welcome',
    welcomeMessage: 'Login to plandag to view your schedule.',
    login: 'Login',
    register: 'Register',
    forgotPassword: 'Forgot Password',
    resetPassword: 'Reset Password',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    rememberMe: 'Remember Me',
    continue: 'Continue',
    selectOrganization: 'Select Organization',
    organizationEmail: 'The email <span class="font-semibold text-[#00165A] bg-slate-100 px-1.5 py-0.5 rounded">{{email}}</span> is associated with multiple organizations.',
    organizationEmailMessage: 'Please select the workspace you\'d like to access.',
    organization: 'Organization',
    chooseOrganization: 'Choose an organization',
    backToLogin: 'Back to login',
    theEmail: 'The email',
    isAssociatedWithMultipleOrganizations: 'is associated with multiple organizations.',
    theSimplestWayToManage: 'The simplest way to manage',
    yourWorkforce: 'your workforce',
    loginRightPanelMessage: 'Empower your team with a management tool built for speed, simplicity, and control. From budget tracking to workflow automation, everything works seamlessly together so you can focus on growth, not administration.',
    personalDetails: 'Personal details',
    businessDetails: 'Business details',
    createYourAccount: 'Create your account',
    name: 'Name',
    willBeUsedAsUsernameForLogin: '(will be used as username for login)',
    enterYourName: 'Enter your name',
    enterYourEmail: 'Enter your email',
    select: '--Select--',
    phoneNumber: 'Phone Number',
    enterYourMobileNumber: 'Enter your mobile number',
    country: 'Country',
    atLeastOneLowercase: 'At least one lowercase',
    atLeastOneUppercase: 'At least one uppercase',
    atLeastOneNumeric: 'At least one numeric',
    minimum8Characters: 'Minimum 8 characters',
    agreeAndContinue: 'Agree and continue',
    personalDetailsMessage: 'This language will be the default for the system notification and new users. You can always adjust it in user settings later on.',
    agreeAndContinueMessage: 'By clicking agree and continue, you confirm that you have read and accepted our Data Processing Agreement, Privacy policy, Trial terms and General terms & consent to receiving sales communication via phone, email, or the Wiser App during your 30-day trial. You can unsubscribe at any time.',
    tellUsAboutYourBusiness: 'Tell us about your business',
    withABusinessDetails: 'With a few business details, we will shape Wiser for your business with your domain',
    businessName: 'Business Name',
    enterYourBusinessName: 'Enter your business name',
    businessLocation: 'Business Location',
    businessType: 'Business Type',
    language: 'Language',
    timezone: 'Timezone',
    howManyEmployeesDoYouHave: 'How many employees do you have?',
    previous: 'Previous',
    createAccount: 'Create Account',
    startYour30DaysTrial: 'Start your 30 days trial',
    noCreditCardRequired: 'No credit card required!',
    exploreWiserFeaturesAtNoCost: 'Explore wiser features at no cost!',
    forgotYourPassword: 'Forgot your password?',
    enterYourEmailAddressAndWeWillSendYou: 'Enter your email address and we will send you',
    instructionsToResetYourPassword: 'instructions to reset your password.',
    youHaveReachedTheEmailRequestLimit: 'You’ve reached the email request limit. Please check your inbox or try again in 15 minutes.',
    checkYourEmail: 'Check your email',
    pleaseCheckTheEmailAddress: 'Please check the email address',
    forInstructionsToResetYourPassword: 'for instructions to reset your password.',
    aNewEmailHasBeenSentToYourInbox: 'A new email has been sent to your inbox.',
    resendEmail: 'Resend email',
    edit: 'Edit',
    thisFieldIsRequired: 'This field is required',
    invalidEmailAddress: 'Invalid email address',
    pleaseEnterAValidEmailAddress: 'Please enter a valid email address',
    invalidPassword: 'Invalid password',
    minimumLengthIs: 'Minimum length is {{length}}',
    maximumLengthIs: 'Maximum length is {{length}}',
    passwordsDoNotMatch: 'Passwords do not match',
    invalidField: 'Invalid field',
} as const;


type TranslationTree<T> = {
    readonly [K in keyof T]: T[K] extends string ? string : TranslationTree<T[K]>;
};

export type Translations = TranslationTree<typeof en>;

export type TranslationKey = keyof typeof en;
